import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useGetCategories } from 'hooks/Categories';
import type { JoinedSparks } from 'types/Spark/JoinedSpark';

type InformationTabProps = {
  joinedSpark: JoinedSparks | undefined;
};

const getCursorStyle = (url?: string | null) => {
  return url ? 'pointer' : 'default';
};

function InformationTab({ joinedSpark }: InformationTabProps) {
  const { categoryIdMap } = useGetCategories();

  const sparkMainCategory = joinedSpark?.sparkCategories?.find(
    (category) => category.attributes.mainCategory
  );
  const mainCategory =
    categoryIdMap?.[sparkMainCategory?.attributes.categoryID || ''];

  const sparkAttributes = joinedSpark?.attributes;

  const privacyPolicyURL = sparkAttributes?.privacyPolicyURL;
  const copyrightURL = sparkAttributes?.copyright;
  const supportURL = sparkAttributes?.supportURL;
  const marketingURL = sparkAttributes?.marketingURL;

  return (
    <Grid container item xs={12} gap={1} sx={{ paddingTop: '8px' }}>
      <Box
        display='flex'
        justifyContent='space-between'
        width='100%'
        p={2}
        borderRadius='10px'
        bgcolor={(theme) => theme.palette.bgGray.main}
      >
        <Typography>Provider</Typography>
        <Typography>
          {joinedSpark?.marketplaceAccount?.attributes.name || '- -'}
        </Typography>
      </Box>
      <Box
        display='flex'
        justifyContent='space-between'
        width='100%'
        p={2}
        borderRadius='10px'
        bgcolor={(theme) => theme.palette.bgGray.main}
      >
        <Typography>Category</Typography>
        <Typography>{mainCategory?.attributes.name || '- -'}</Typography>
      </Box>
      <Box
        display='flex'
        justifyContent='space-between'
        width='100%'
        p={2}
        borderRadius='10px'
        bgcolor={(theme) => theme.palette.bgGray.main}
      >
        <Typography>Privacy Policy</Typography>
        <Typography
          sx={{
            '&:hover': {
              cursor: getCursorStyle(privacyPolicyURL),
            },
          }}
          onClick={() => {
            if (privacyPolicyURL) window.open(privacyPolicyURL);
          }}
        >
          {privacyPolicyURL || '- -'}
        </Typography>
      </Box>
      <Box
        display='flex'
        justifyContent='space-between'
        width='100%'
        p={2}
        borderRadius='10px'
        bgcolor={(theme) => theme.palette.bgGray.main}
      >
        <Typography>Copyright</Typography>
        <Typography
          sx={{
            '&:hover': {
              cursor: getCursorStyle(copyrightURL),
            },
          }}
          onClick={() => {
            if (copyrightURL) window.open(copyrightURL);
          }}
        >
          {copyrightURL || '- -'}
        </Typography>
      </Box>
      <Box
        display='flex'
        justifyContent='space-between'
        width='100%'
        p={2}
        borderRadius='10px'
        bgcolor={(theme) => theme.palette.bgGray.main}
      >
        <Typography>Support</Typography>
        <Typography
          sx={{
            '&:hover': {
              cursor: getCursorStyle(supportURL),
            },
          }}
          onClick={() => {
            if (supportURL) window.open(supportURL);
          }}
        >
          {supportURL || '- -'}
        </Typography>
      </Box>
      <Box
        display='flex'
        justifyContent='space-between'
        width='100%'
        p={2}
        borderRadius='10px'
        bgcolor={(theme) => theme.palette.bgGray.main}
      >
        <Typography>Marketing</Typography>
        <Typography
          sx={{
            '&:hover': {
              cursor: getCursorStyle(marketingURL),
            },
          }}
          onClick={() => {
            if (marketingURL) window.open(marketingURL);
          }}
        >
          {marketingURL || '- -'}
        </Typography>
      </Box>
    </Grid>
  );
}

export default InformationTab;
